module.exports = __webpack_public_path__ + "static/media/harabharakabab.7ca7ebad.jpg";